function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.733 6.51741L13.6193 0.272768C13.4489 0.0986608 13.2188 0 12.9773 0H0.909091C0.40625 0 0 0.414955 0 0.928571V25.0714C0 25.585 0.40625 26 0.909091 26H19.0909C19.5938 26 20 25.585 20 25.0714V7.17612C20 6.92946 19.9034 6.69152 19.733 6.51741ZM12.5568 2.14152L17.9034 7.60268H12.5568V2.14152ZM17.9545 23.9107H2.04545V2.08929H10.625V8.35714C10.625 8.68038 10.7507 8.99037 10.9745 9.21893C11.1982 9.44749 11.5017 9.57589 11.8182 9.57589H17.9545V23.9107Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.47475 13.1032H7V11.6992H13.3636V13.1032H10.8767V20.7992H9.47475V13.1032Z",
  fill: "currentColor"
});

var SvgIcTutorial = function SvgIcTutorial(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcTutorial, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_tutorial.34fcd267.svg";
export { ForwardRef as ReactComponent };